import { Chip, Collapse } from '@mui/material';
import Divider from '@mui/material/Divider';
import { Observer } from 'mobx-react-lite';
import { MapItemType } from 'modules/Synchronisation/EQTiming/types';
import { CustomFields } from 'modules/Synchronisation/RaceResults/components';
import * as React from 'react';

import { InputWrapper, AutocompleteSelectInfinityLoad } from 'src/components/Form';
import { form } from 'src/stores';
import { t } from 'src/utils';

import { Show } from 'components/Condition';

import { RACE_RESULTS_FORM_ID } from '../../constants';

import { handleAddItem, handleAfterSelectDistance, handleDeleteItem } from '../../actions';

import { ColumnTitle, FieldColumns, SyncContainer, SyncItem } from '../../../Shared';
import { getRaceDistanceOptions, getSyncDistanceOptions, showDistancePlus } from '../../selectors';

export const Distances = () => {
  return (
    <Observer>
      {() => {
        const data = form.fetch<MapItemType[]>(RACE_RESULTS_FORM_ID, 'distances') || [];

        return (
          <SyncContainer
            title={t.staticAsString('coupons.new.distances')}
            addText={'Add distance'}
            onAdd={handleAddItem('distances')}
            showPlus={showDistancePlus.get()}
            hideFieldsTitles
          >
            {data.map((item, index) => {
              return (
                <Collapse key={item.id}>
                  <Show if={Boolean(item.internal_id?.label)}>
                    <Divider textAlign='left'>
                      <Chip label={item.internal_id?.label} />
                    </Divider>
                  </Show>
                  <Show if={!Boolean(item.internal_id?.label)}>
                    <Divider sx={{ margin: '17px 0' }} />
                  </Show>

                  <FieldColumns>
                    <ColumnTitle>{t('races.filters.id')}</ColumnTitle>
                    <ColumnTitle>{t('sync.race_results')}</ColumnTitle>
                  </FieldColumns>

                  <SyncItem
                    key={item.id}
                    onDelete={handleDeleteItem('distances', item.id)}
                    bottomComponent={
                      <>
                        <CustomFields distanceIndex={index} />
                      </>
                    }
                  >
                    <InputWrapper
                      name={`distances.${index}.internal_id`}
                      settings={{
                        label: t.staticAsString('sync.distance.raceid_title'),
                        additional: {
                          options: getRaceDistanceOptions.get(),
                        },
                        view: {
                          reservePlaceForHelperText: true,
                        },
                        afterSelect: () => handleAfterSelectDistance(`distances.${index}`),
                      }}
                      Component={AutocompleteSelectInfinityLoad}
                    />
                    <InputWrapper
                      key={item.id}
                      name={`distances.${index}.external_id`}
                      settings={{
                        label: t.staticAsString('sync.distance.external_title'),
                        additional: {
                          options: getSyncDistanceOptions.get(),
                        },
                        view: {
                          reservePlaceForHelperText: true,
                        },
                        afterSelect: () => handleAfterSelectDistance(`distances.${index}`),
                      }}
                      Component={AutocompleteSelectInfinityLoad}
                    />
                  </SyncItem>
                </Collapse>
              );
            })}
          </SyncContainer>
        );
      }}
    </Observer>
  );
};
